/* eslint-disable */
import { ViewOMSVectorLayer } from "../types/omjs/view";
import {getMaxPolygonFromMultiPolygon} from "./index";

omjs.View.prototype['handleMapPointerEvents'] = function(evt) {
    const layerAndFeature = {
        layer: false,
        feature: false
    };

    layerAndFeature.layer = this._map.forEachLayerAtPixel(evt.pixel, function(layer) {
        const omjsLayer = layer.get('omjsLayer');
        if (omjsLayer && omjsLayer.hasEventListeners(evt.type)) {
            if (omjsLayer instanceof omjs.View.VectorLayer
                || omjsLayer instanceof omjs.View.ImageLayer
                || omjsLayer instanceof omjs.View.MVTLayer) {
                return omjsLayer;
            } else if (omjsLayer instanceof omjs.View.ExternalLayer) {
                const meta = omjsLayer.getProjectLayers().at(0).get('meta');
                const { showObjects } = meta.settings;
                // WFS, GeoJSON, MVT       либо     WMS, ArcGIS + включено showObjects
                if (!!~[ 3, 6, 7 ].indexOf(meta.type) || (!!~[ 2, 5 ].indexOf(meta.type) && showObjects)) {
                    return omjsLayer;
                }
            }
        }
        return false;
    }, null, l => l.getSource() !== null);

    try {
        if (layerAndFeature.layer) {
            layerAndFeature.feature = this._map.forEachFeatureAtPixel(evt.pixel, f => f, {
                layerFilter: l => l.get('omjsLayer') && l.get('omjsLayer').guid === layerAndFeature.layer['guid']
            });
        }
    } catch (e) {
        layerAndFeature.feature = false;
    }

    if (layerAndFeature.layer) {
        if (evt.type === 'click' || evt.type === 'singleclick' || evt.type === 'dblclick') {
            this._utfIgnoreClick = true;
            clearTimeout(this._utfIgnoreClickTimer);
            this._utfIgnoreClickTimer = setTimeout(() => {
                this._utfIgnoreClick = false;
            }, 100);
        }

        const type = layerAndFeature.layer['getProjectLayers']().at(0).get('type');

        if (layerAndFeature.feature || type === 'external') {
            layerAndFeature.layer['fire'](evt.type, {
                feature: layerAndFeature.feature ? layerAndFeature.feature : undefined,
                olEvent: evt
            });
        }

        if (layerAndFeature.feature) {
            if (evt.type === 'pointermove' && omjs.ol.events.condition.mouseOnly(evt)) {
                if (this._selected['feature'] !== layerAndFeature['feature']) {
                    if (this._selected['feature']) {
                        this._selected['layer'].fire('pointerleave', {
                            feature: this._selected['feature'],
                            olEvent: evt
                        });
                    }

                    this._selected = layerAndFeature;
                    this._selected['layer'].fire('pointerenter', {
                        feature: this._selected['feature'],
                        olEvent: evt
                    });
                }
            }
        } else if (type === 'external') {
            if (evt.type === 'pointermove' && omjs.ol.events.condition.mouseOnly(evt)) {
                if (this._selected['layer'] !== layerAndFeature.layer) {
                    if (this._selected['layer']) {
                        this._selected['layer'].fire('pointerleave', {
                            feature: this._selected['feature'],
                            olEvent: evt
                        });
                    }

                    this._selected = layerAndFeature;
                    this._selected['layer'].fire('pointerenter', {
                        olEvent: evt
                    });
                }
            }
        }
    } else {
        if (evt.type === 'pointermove' && this._selected['layer']) {
            this._selected['layer'].fire('pointerleave', {
                feature: this._selected['feature'],
                olEvent: evt
            });
            this._selected['feature'] = false;
            this._selected['layer'] = false;
        }
    }
};

omjs.View.prototype['mapEventsOn'] = function() {
    if (!this._selected) {
        this._selected = {
            layer: false,
            feature: false
        };
    }

    this._map.on([ 'click', 'dblclick', 'pointermove', 'singleclick' ], this.handleMapPointerEvents);
};

omjs.View.prototype['mapEventsOff'] = function() {
    this._map.un([ 'click', 'dblclick', 'pointermove', 'singleclick' ], this.handleMapPointerEvents);
};

omjs.View['BaseLayer'].prototype['_createSources'] = function () {
    var that = this,
        url;

    that.options['base_maps'].forEach(function (base, i) {
        if (base.type == 'OMS') {
            if (!base.vector) return;
            that.sources[base.id] = base.container_id + '';
            if (that.mapboxGlContainer) return;
            that.mapboxGlContainer           = document.createElement('div');
            that.mapboxGlContainer.className = 'omjs-map-container omjs-mapboxgl-base';
            that._container.appendChild(that.mapboxGlContainer);
        } else {
            if (base.type == 'PUBLIC_SERVICE') {
                if (base.value == 'OSM') {
                    that.sources[base.id] = new ol.source.OSM({
                        crossOrigin : "anonymous",
                        attributions: [
                            '&nbsp;', // место под иконку
                            '&copy; ' +
                            '<a href="http://www.openstreetmap.org/copyright" target="_blank">'
                            + that.view.Lang.translate('Участники OpenStreetMap')
                            + '</a>'
                        ],
                        tileLoadFunction: (imageTile, src) => {
                            const img = imageTile.getImage();
                            // Set the per-image referrer policy before assigning the src
                            if (img && 'referrerPolicy' in img) {
                                img.referrerPolicy = 'origin-when-cross-origin';
                            }
                            img.src = src;
                        }
                    });
                }
                if (base.value == 'ORBISMapBaseMap') {
                    var xyzUrl = "https://maps.orbismap.ru/base.png?x={x}&y={-y}&z={z}";
                    var tilePixelRatio = 1;
                    if (that._pixelRatio > 1) {
                        xyzUrl += '&retina=' + that._pixelRatio;
                        tilePixelRatio = that._pixelRatio;
                    }
                    that.sources[base.id] = new ol.source.XYZ({
                        crossOrigin: "anonymous",
                        url        : xyzUrl,
                        tilePixelRatio: tilePixelRatio
                    });
                }
                if (~base.value.indexOf('yandex') || ~base.value.indexOf('google')) {
                    that.sources[base.id] = base.value;
                    if (~base.value.indexOf('yandex') && !that.yaContainer) {
                        that.yaContainer           = document.createElement('div');
                        that.yaContainer.className = 'omjs-map-container omjs-yandex-base';
                        that._container.appendChild(that.yaContainer);
                    }
                    if (~base.value.indexOf('google') && !that.googContainer) {
                        that.googContainer           = document.createElement('div');
                        that.googContainer.className = 'omjs-map-container omjs-google-base';
                        that._container.appendChild(that.googContainer);
                    }
                }

                if (base.value == 'cadastre') {
                    that._createPKKLayers();
                }
            } else if (base.type === 'XYZ') {
                var rPixelRatio = /\{pixelratio([&?][^=]*)?=([^}]+)\}/;
                var res = base.value.match(rPixelRatio);
                var replacer = '';
                var xValues;
                var xVar = '';
                var xVal;
                var xyzUrl = String(base.value);
                var tilePixelRatio = 1;
                if (res) {
                    if (res.length === 3) {
                        if (res[1]) {
                            xVar += res[1] + '=';
                        }
                        xValues = res[2].split(',');
                    } else {
                        xValues = res[1].split(',');
                    }

                    if (that._pixelRatio === 1) {
                        xVal = xValues[that._pixelRatio-1];
                    } else {
                        for ( var n = that._pixelRatio -1; n > 0; n--) {
                            xVal = xValues[n];
                            if (xVal && xVal.trim() !== '') {
                                tilePixelRatio = n + 1;
                                break;
                            }
                        }
                    }

                    if (xVal && xVal.trim() !== "") {
                        replacer = xVar + xVal;
                    }
                    xyzUrl = xyzUrl.replace(res[0], replacer);
                }

                that.sources[base.id] = new ol.source.XYZ({
                    crossOrigin: "anonymous",
                    url        : xyzUrl,
                    tilePixelRatio: tilePixelRatio
                });
            } else if (base.type == 'WMS') {
                var wmsJson = JSON.parse(base.value);
                url         = wmsJson['url'];
                delete wmsJson['url'];

                that.sources[base.id] = new ol.source.TileWMS({
                    crossOrigin: "anonymous",
                    url        : url,
                    params     : wmsJson
                });
            } else if (base.type == 'ARCGIS') {
                var arcGisJson = JSON.parse(base.value);
                url            = arcGisJson['url'];
                delete arcGisJson['url'];

                that.sources[base.id] = new ol.source.TileArcGISRest({
                    crossOrigin: "anonymous",
                    url        : url,
                    params     : arcGisJson
                });
            }
        }
    });

    return that;
}

const setImageGamma = (canvas, context, gamma) => {
    const pix = context.getImageData(0, 0, canvas.width, canvas.height);
    let ret;
    // Loop through the pixels
    for (let x = 0; x < canvas.width; x++) {
        for (let y = 0; y < canvas.height; y++) {
            let i = (y * canvas.width + x) * 4;
            let r = pix.data[i];
            let g = pix.data[i + 1];
            let b = pix.data[i + 2];
            let a = pix.data[i + 3];
            ret = [ r * gamma * gamma, g * gamma * gamma, b * gamma * gamma, a ];

            /* eslint-disable prefer-destructuring */
            pix.data[i] = ret[0];
            pix.data[i + 1] = ret[1];
            pix.data[i + 2] = ret[2];
            pix.data[i + 3] = ret[3];
            /* eslint-enable prefer-destructuring */
        }
    }

    // Put the image back to the canvas
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.putImageData(pix, 0, 0);
};


const devPixelRatio = 1 / Math.ceil(omjs['Utils'].getDevicePixelRatio());

const { ol } = omjs;

const defaultStyle = {
    fill: 'rgba(8,203,239,0.5)',
    strokeColor: `#002d9a`,
    strokeWidth: 1
}

const defaultSitesStyle = {
    fill: '#00ccbb',
    strokeColor: `#808080`,
    strokeWidth: 1
}

const setFeatureStyle = (style: any | undefined, geometry?: any, layer?: ViewOMSVectorLayer) => {
    let featureStyle = style || defaultStyle;
    if (layer) {
        const code = layer.getProjectLayers().at(0).get('code');
        if (['sites_1', 'sites_2', 'sites_3', 'sites_4'].includes(code)) {
            featureStyle = defaultSitesStyle;
        }
    }
    const options: any = {}

    if (featureStyle.fill) {
        options.fill = new ol.style.Fill({
            color: featureStyle?.fill || ''
        })
    }
    if (featureStyle.strokeWidth) {
        options.stroke = new ol.style.Stroke({
            color: featureStyle.strokeColor || '',
            width: featureStyle?.strokeWidth || 0
        })
    }
    if ((featureStyle.fill === null) && (featureStyle.strokeColor === null)) {
        options.fill = new ol.style.Fill({
            color: defaultStyle.fill
        })
    }
    if (geometry) options.geometry = geometry;
    return new ol.style.Style(options)
}

const clusterLayerSetup = function(options){
    var that     = this;

    options || (options = {});
    
    if('projectLayers' in options){
        that._prjLayers = options.projectLayers;
    }
    
    if(that._prjLayers && that._prjLayers.getLength() > 0){
        that._olSource = new ol.source.Vector({
            features: that.getFeatures()
        });
        
        if(that.options['clustering']){
            
            const prgLayer = that._prjLayers.at(0);
            const json = prgLayer.get('json');
            that._olClusterSource = new ol.source.Cluster({
                distance: that.options['clustering'],
                source  : that._olSource
            });
            if (json.cms_geom_style) {
                that._olClusterSource.geometryFunction = (feature) => {
                    let type = feature.getGeometry().getType();
                    let geom = feature.getGeometry();
                    if (type === 'Polygon') {
                        geom = feature.getGeometry().getInteriorPoint();
                    } else if (type === 'MultiPolygon') {
                        const pol = feature.getGeometry().getPolygon(0);
                        geom = pol.getInteriorPoint();
                    } else if (type === 'LineString') {
                        geom = feature.getGeometry().getCoordinateAt(0.5);
                    }
                    return geom;
                }
            }
            
            that._olLayer.setSource(that._olClusterSource);
        }else{
            that._olLayer.setSource(that._olSource);
        }
    }
    return that;
}

const setLayerStyle = function() {
    const that = this;
    const layer = this._olLayer;
    const vStyle = this._prjLayers.at(0).get('vectorSettings');
    const vCode = this._prjLayers.at(0).get('code');
    let iconImg;
    // update images, then set layer style function
    this._reloadLayerIcons().done(() => {
        // Чистим сохраненные стили
        this.styleCache = {};
        layer.setStyle((feature, resolution) => {
            let size = feature.get('features') ? feature.get('features').length : 1;
            let styles = [];
            let scale;
            let offset = vStyle.stylesPoint.iconOffsetEnabled
                ? [ -vStyle.stylesPoint.iconDx / devPixelRatio, -vStyle.stylesPoint.iconDy / devPixelRatio ]
                : [ 0, 0 ];
            let featureHighlighted = !!feature.get('highlighted');
            const styleOptions: any = {};
            const geomType = feature?.getGeometry()?.getType();
            const zoom = that.map.getView().getZoom();
            let featureId = geomType === 'Point' ? '' : `:${feature.get('obj').id}`;
            let cacheKey = `${resolution}:${featureHighlighted ? '1' : '0'}${featureId}`;

            if (cacheKey in that.styleCache) {
                if (that.styleCache[cacheKey][size]) {
                    return that.styleCache[cacheKey][size];
                }
            } else {
                that.styleCache[cacheKey] = [];
            }
            if (geomType !== 'Point') {
                if (geomType === 'Polygon') styleOptions.geometry = feature?.getGeometry().getInteriorPoint()
                else if (geomType === 'MultiPolygon') {
                    if (['sites_1', 'sites_2', 'sites_3', 'sites_4', 'investment_projects'].includes(vCode)) {

                        const largestPolygon = getMaxPolygonFromMultiPolygon(feature.getGeometry());
                        styleOptions.geometry = largestPolygon.getInteriorPoint();
                    } else styleOptions.geometry = feature.getGeometry().getInteriorPoints()
                }
                if (zoom > 10) {
                    const fStyles = feature.get('obj').get('geom_style') || [];
                    if (geomType === 'Polygon') {
                        styles.push(setFeatureStyle(fStyles[0], undefined, that))
                    } else if (geomType === 'MultiPolygon') {
                        const polygons = feature.getGeometry().getPolygons();
                        for (let i in polygons) {
                            styles.push(setFeatureStyle(fStyles[i], polygons[i], that))
                        }
                    }
                }
            }

            if (size > 1) {
                let min = 2;
                let max = 2;
                layer.getSource().getFeatures().forEach((f) => {
                    min = Math.min(min, f.get('features').length);
                    max = Math.max(max, f.get('features').length);
                });

                const sizeDelta = vStyle.clusterSettings.iconSizeMax - vStyle.clusterSettings.iconSizeMin;
                // eslint-disable-next-line no-mixed-operators
                const iconSize = parseInt(vStyle.clusterSettings.iconSizeMin + sizeDelta * (size - min) / (max - min));

                if (vStyle.clusterSettings.icon != null && vStyle.clusterSettings.iconEnabled) {
                    iconImg = that.imgCache[vStyle.clusterSettings.icon];
                    offset = vStyle.clusterSettings.iconOffsetEnabled
                        ? [ -vStyle.clusterSettings.iconDx, -vStyle.clusterSettings.iconDy ]
                        : [ 0, 0 ];
                } else {
                    iconImg = that.imgCache[vStyle.stylesPoint.icon];
                    offset = vStyle.stylesPoint.iconOffsetEnabled
                        ? [ -vStyle.stylesPoint.iconDx / devPixelRatio, -vStyle.stylesPoint.iconDy / devPixelRatio ]
                        : [ 0, 0 ];
                }

                offset[0] += iconImg.width / 2;
                offset[1] += iconImg.height / 2;

                scale = vStyle.clusterSettings.iconSizeEnabled ? iconSize / iconImg.width : 1;
                // scale = 1;

                styles.push(new ol.style.Style({
                    image: new ol.style.Icon({
                        anchor: offset,
                        anchorXUnits: 'pixels',
                        anchorYUnits: 'pixels',
                        opacity: 1,
                        img: iconImg,
                        imgSize: [ iconImg.width, iconImg.height ],
                        scale: scale * (iconImg.needToScale ? devPixelRatio : 1)
                    }),
                    ...styleOptions
                }));

                // count style
                if (vStyle.clusterSettings.showObjectsCount) {
                    try {
                        scale = 1 / (that.pixelRatio || devPixelRatio);
                        const countIcon = omjs['Utils'].createObjectsCountCnv(
                            size < 100 ? size.toString() : '*', scale,
                            that.cluserSizeOptions
                        );
                        styles.push(new ol.style.Style({
                            image: new ol.style.Icon({
                                anchor: [
                                    (that.cluserSizeOptions.width / 2 - vStyle.clusterSettings.objectsCountDx) * scale,
                                    (that.cluserSizeOptions.height / 2 - vStyle.clusterSettings.objectsCountDy) * scale
                                ],
                                anchorXUnits: 'pixels',
                                anchorYUnits: 'pixels',
                                opacity: 1,
                                imgSize: [ countIcon.width, countIcon.height ],
                                img: countIcon,
                                scale: 1 / scale
                            }),
                            ...styleOptions
                        }));
                    } catch (err) {
                        // eslint-disable-next-line no-console
                        console.error(err);
                    }
                }
            } else {
                // one feature style
                iconImg = that.imgCache[vStyle.stylesPoint.icon];
                offset[0] += (iconImg.width / 2);
                offset[1] += (iconImg.height / 2);

                styles.push(new ol.style.Style({
                    image: new ol.style.Icon({
                        anchor: offset,
                        anchorXUnits: 'pixels',
                        anchorYUnits: 'pixels',
                        opacity: 1,
                        img: iconImg,
                        imgSize: [ iconImg.width, iconImg.height ],
                        scale: iconImg.needToScale ? devPixelRatio : 1
                    }),
                    ...styleOptions
                }));
                // styles.push(new ol.style.Style({
                //     image: new ol.style.Circle({
                //         radius: 5,
                //         stroke: new ol.style.Stroke({ color: '#ff0000' })
                //     })
                // }));
            }

            if (featureHighlighted) {
                let highlightStyle;
                let imageSize;
                let canvas;
                let shadowOffset;
                let canvasContext;
                highlightStyle = styles.filter(style => !!style.getImage());
                if (highlightStyle && highlightStyle.length) {
                    // во избежание моргания иконки при наведении не стоит стирать её страый стиль
                    // новый просто наложится сверху (но для иконок с прозрачностью будет заметно!)
                    // styles = [];
                    for (let styleIndex = 0; styleIndex < highlightStyle.length; styleIndex++) {
                        imageSize = highlightStyle[styleIndex].getImage().getImageSize();
                        canvas = omjs['$']('<canvas />');
                        shadowOffset = 2;
                        canvas
                            .attr({
                                width: imageSize[0] + shadowOffset * 2,
                                height: imageSize[1] + shadowOffset * 2
                            })
                            .css({
                                width: imageSize[0] + shadowOffset * 2,
                                height: imageSize[1] + shadowOffset * 2
                            });
                        canvasContext = canvas[0].getContext('2d');

                        canvasContext.shadowColor = 'rgba( 0, 0, 0, 0.3 )';
                        canvasContext.shadowOffsetX = shadowOffset;
                        canvasContext.shadowOffsetY = shadowOffset;
                        canvasContext.shadowBlur = shadowOffset;
                        canvasContext.drawImage(
                            highlightStyle[styleIndex].getImage().getImage(),
                            shadowOffset,
                            shadowOffset
                        );

                        try {
                            setImageGamma(canvas[0], canvasContext, 1.06);
                            let anchor = highlightStyle[styleIndex].getImage().getAnchor().map(a => a + shadowOffset);
                            styles.push(new ol.style.Style({
                                image: new ol.style.Icon({
                                    src: canvas[0].toDataURL(),
                                    scale: highlightStyle[styleIndex].getImage().getScale(),
                                    opacity: 1,
                                    anchor: anchor,
                                    anchorXUnits: 'pixels',
                                    anchorYUnits: 'pixels'
                                }),
                                ...styleOptions
                            }));
                        } catch (e) {
                            highlightStyle[styleIndex].getImage().setOpacity(
                                highlightStyle[styleIndex].getImage().getOpacity() * 0.6
                            );
                            styles.push(highlightStyle[styleIndex]);
                        }
                        canvas.detach();
                    }
                }
            }

            if (zoom < 11) {
                if (vCode.indexOf('programs_') === 0) {
                    styles = [ new ol.style.Style({
                        image: new ol.style.Icon({
                            // eslint-disable-next-line max-len
                            src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIKSURBVHgBzVY9SEJRFD5PGhoKGhoKGhwKGl/QGFTQELQUBLYUBU7R4FQNgjdoaMsgWhIKWgoEp6DNpKBF0MEhSMghyCFI0iFIeJ3vda/cJ76nqYMfHO+93p/vnXv+LlGvwLKsOZYky6eUBItJ3QIfFrHcEaFOoQjKXz/WxfmrtbTwYAWWn+y+huNm5xgeBMvcJNAP7+XoMfXhmJ+ZHab98CQNDPZhmGVZMQyj0DIJE/i5ybAMXcYKBGmEkdF+ip6ZdsvAovlGRD4XgiQI4jdvrgRA8f2bQttZyr9UMMS+jLwBb014ETQwsTG4nqZWsRMap9W1MTUUrNEBNdJEGtHEF4Z3c/QfnEbzutZC9zxDI8CfolKuUnAjbV9FO6hzCNjo3icJEFgC/aPD57YJAHghbClha+PTB1C33lXbQfy6RmLqJHP4ubstUjcgr6oGh+ErlSp1A4tLI6qb0kkQsbQaGKNOAcNvBv1qKHQS26fh51jULhD58Cx1JnuW/fG6CwvSHMAr0t0ItBRzwgQhNeeIeJ0IHoIAaxWxq2kanxhAN8sEU/qcw/A8KbhZYSnh6rBRfpknkFIkQUHud8ArCyNJ+lUSdAtQGFkausQy1VIWtpn/Fs6zZKEJNGrkEHWetOVWT5qCtYqqEoiKiMqICok+KqaEoE6BQzzqvKBuAUlUvlLUiyWJVwz1Cn4BB/lYdVN7/W0AAAAASUVORK5CYII=',
                            scale: 1,
                            opacity: 1,
                            anchor: [ 5, 5 ],
                            anchorXUnits: 'pixels',
                            anchorYUnits: 'pixels'
                        })
                    }) ];

                    if (size > 1 && vStyle.clusterSettings.showObjectsCount) {
                        try {
                            scale = 1 / (that.pixelRatio || devPixelRatio);
                            const countIcon = omjs['Utils'].createObjectsCountCnv(
                                size < 100 ? size.toString() : '*', scale,
                                that.cluserSizeOptions
                            );

                            styles.push(new ol.style.Style({
                                image: new ol.style.Icon({
                                    anchor: [
                                        (-10) * scale,
                                        (11) * scale
                                    ],
                                    anchorXUnits: 'pixels',
                                    anchorYUnits: 'pixels',
                                    opacity: 1,
                                    imgSize: [ countIcon.width, countIcon.height ],
                                    img: countIcon,
                                    scale: 1 / scale
                                })
                            }));
                        } catch (err) {
                            // eslint-disable-next-line no-console
                            console.error(err);
                        }
                    }
                }
            }

            that.styleCache[cacheKey][size] = styles;
            return styles;
        });
    });
};

const getCachedContainers = function() {
    let containersArray = [];
    if (this._cache.containers && this._cache.containers.getLength() > 0) {
        containersArray = this._cache.containers.getArray();
    }
    return containersArray;
}

const getCachedPubContainers = function() {
    let containersArray = [];
    if (this._cache.publishContainers && this._cache.publishContainers.getLength() > 0) {
        containersArray = this._cache.publishContainers.getArray();
    }
    return containersArray;
}

const loadObjects = function (options) {
    var that = this;

    options || (options = {});
    if('raw' in options){
        delete options['raw']
    }
    if (that.get('json')?.cms_geom_style) {
        options.geomCentroid = '0';
    }
    options.escape = 0;
    return that.project.loadObjects(that.get('code'), options).then(function(objects){
        let arr = objects.getArray();

        arr = arr.filter(o => {
            if (o.getGeometry() && o.getGeometry().type === 'GeometryCollection') {
                console.log(o.options.layerCode);
            }
            return !o.getGeometry() || o.getGeometry().type !== 'GeometryCollection';
        })

        that.objects.reset(arr);
        return that.objects;
    })
}

const getMinMaxValues = function(type) {
    var that = this,
        min,
        max,
        features,
        value;

    if (that.minMaxValues) {
        return;
    }

    features = that._prjLayer.objects;
    if (features.length == 0) {
        return;
    }

    switch(type) {
        // сумма значений
        case 2:
            //найдем минимальное и максимальное значение по суммам
            features.each(function(feature){
                value = false;
                that.columnStyles.forEach(function(column){
                    var v;
                    if(that.newArray[column.sort] == column.id) {
                        v = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
                    }else {
                        v = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
                    }
                    if (v != null) {
                        value += v;
                    }
                });

                if (value) {
                    if (!min || value < min) {
                        min = value;
                    }
                    if (!max || value > max) {
                        max = value;
                    }
                }
            });
            that.minMaxValues = [min, max];
            break;

        // по колонке
        case 3:
            //найдем минимальное и максимальное значение по колонке
            //найдем минимальное и максимальное значение по колонке
            features.each(function (feature) {
                value = feature.get(that.sizeColumnCode || 'razm');

                if (value != null) {
                    if (!min || value < min) {
                        min = value;
                    }
                    if (!max || value > max) {
                        max = value;
                    }
                }
            });
            that.minMaxValues = [min, max];

            break;
    }
}

const getChartSize = function (feature) {
    const that = this;
    const visStyle = that._prjLayer.get("visualSettings");
    const { classesSettings } = that._prjLayer.get("visualSettings");
    let value;

    // для линейных и столбчатых диаграмм нужно посчитать ширину шкалы
    let scaleWidth = 0;

    if (visStyle.type == 5 || visStyle.type == 6) {
        // если шкала включена, считаем, сколько она должна занять места
        if (classesSettings.showScale) {
            scaleWidth = Math.max(that.minMaxScaleValues[0].toString().length + 1, that.minMaxScaleValues[1].toString().length + 1) * 5;
        }
    }

    if (classesSettings.sizeType == 1) {
        // для фиксированного графика сразу возвращаем размеры
        return {w: classesSettings.sizeValue + scaleWidth, h: classesSettings.sizeValue};
    } else {
        // иначе ищем мин макс значения среди всех фич в зависимости от типа графика
        that._getMinMaxValues(classesSettings.sizeType);
        if (that.minMaxValues[1] == that.minMaxValues[0]) {
            // если не смогли найти мин макс, берем средний арифметический размер графика
            var size = (classesSettings.sizeTo - classesSettings.sizeFrom) / 2;
            return {w: size + scaleWidth, h: size};
        }
    }

    // считаем значение конкретной фичи, чтобы потом рассчитать пропорцию
    if (classesSettings.sizeType == 2) {
        value = 0;
        that.columnStyles.forEach(function(column){
            var v;
            if(that.newArray[column.sort] == column.id) {
                v = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
            }else {
                v = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
            }
            if (v != null) {
                value += v;
            }

        });
    } else if (classesSettings.sizeType == 3) {
        value = feature.get(that.sizeColumnCode || 'razm');
    }

    //считаем размер графика в пропорции
    let sizeDelta = classesSettings.sizeTo - classesSettings.sizeFrom;
    let chartSize = parseInt(classesSettings.sizeFrom + sizeDelta * (value - that.minMaxValues[0]) / (that.minMaxValues[1] - that.minMaxValues[0]));
    return {w: chartSize + scaleWidth, h: chartSize};
}

const createPieChart = function(canvas, feature) {
    var that = this,
        data = [],
        labels = [],
        colors = [],
        value;

    var pixelRatio = that.pixelRatio ? that.pixelRatio : devPixelRatio;

    var options = {
        animation : false,
        cutoutPercentage:-1
    };

    let trueValuesCount = 0;
    that.columnStyles.forEach(function(column) {
        if(that.newArray[column.sort] == column.id) {
            value = (that._prjLayer.get('visualSettings').columnCode == 'orbis_id') ? feature.getId() :  feature.get(that._prjLayer.get('visualSettings').columnCode);
        }else {
            value = (that.newArray[column.sort] == 'orbis_id') ? feature.getId() : feature.get(that.newArray[column.sort]);
        }
        if (value != null) {
            data.push(typeof value === 'boolean' ? +value : value);
            colors.push(column.color);
            labels.push("");
        }
        if (value !== null && value > 0) {
            trueValuesCount += 1;
        }
    });

    if (data.length == 0) {
        canvas.attr('no-data', 1);
        return;
    }

    var chartData = {
        labels: labels,
        datasets: [
            {
                data: data,
                backgroundColor: colors
            }
        ]
    };

    // если график строится только по одной колонке, убираем бордер у сегментов и рисуем один общий бордер
    if (that.columnStyles.length == 1 || trueValuesCount <= 1) {
        chartData.datasets[0]['borderWidth'] = 0;
    }

    // @ts-ignore
    new Chart(canvas[0].getContext("2d"), {
        type: 'pie',
        data: chartData,
        options: options
    });

    if (that.columnStyles.length == 1 || trueValuesCount <= 1) {
        var obCanvas = canvas[0].getContext('2d');
        obCanvas.beginPath();
        obCanvas.arc(canvas[0].width*pixelRatio/2, canvas[0].width*pixelRatio/2, (canvas[0].width/2-1)*pixelRatio, 0, 2*Math.PI, false);
        obCanvas.lineWidth = 2;
        obCanvas.strokeStyle = '#fff';
        obCanvas.stroke();
    }
}

function vectorLayerReloadIcons() {
    let { $ } = omjs;

    var that = this,
        master = $.Deferred(),
        defs = [],
        i, vStyle,
        url;

    vStyle = that._prjLayers.at(0).get('vectorSettings');

    that.imgCache = {};

    if(vStyle.stylesPoint.icon) {
        defs.push(that._createImgLoader(vStyle.stylesPoint.icon));
    }


    if(vStyle.clusteringEnabled && vStyle.clusterSettings.icon && vStyle.clusterSettings.iconEnabled
        && that.imgCache[ vStyle.clusterSettings.icon ] === undefined) {
        defs.push(that._createImgLoader(vStyle.clusterSettings.icon));
    }

    if(_.isEmpty(that.imgCache)) {
        master.resolve(true);
        return master;
    }

    $.when.apply($, defs).then(() => master.resolve(true));
    const customPixelRatio = window['customDevicePixelRatio'];
    for(i in that.imgCache) {
        url = that.project.apiUrlLocation.protocol
            + '//'
            + that.project.apiUrlLocation.hostname
            // Добавилась эта строка
            + (that.project.apiUrlLocation.port ? `:${that.project.apiUrlLocation.port}` : '')
            + i + '?r=' + Math.floor(Math.random() * (999999)) + 1;
        that.imgCache[ i ].src = customPixelRatio ? url : `${url}&retina=${1 / devPixelRatio}`;
        // that.imgCache[ i ].src = `${url}&retina=${1 / devPixelRatio}`;
        if (i.indexOf('.svg') !== -1) {
            that.imgCache[ i ].needToScale = true;
        }
    }
    return master;
}

function categoryLayerReloadIcons() {
    let { $ } = omjs;
    // let { _ } = window;

    var that = this,
        master = $.Deferred(),
        defs = [],
        vStyle,
        classes,
        defClass,
        i,
        url;

    that.imgCache = {};


    classes = that._prjLayer.get('visualSettings')[ 'classesSettings' ].classes;
    defClass = that._prjLayer.get('visualSettings')[ 'classesSettings' ].defaultClass;
    vStyle = that._prjLayer.get('vectorSettings');

    for(var c in classes) {
        if(classes[ c ].icon && classes[ c ].icon != "" && classes[ c ].icon != null && that.imgCache[ classes[ c ].icon ] === undefined) {
            defs.push(that._createImgLoader(classes[ c ].icon));
        }
    }

    if(vStyle[ 'clusteringEnabled' ] && vStyle[ 'clusterSettings' ].icon != null && vStyle.clusterSettings.iconEnabled
        && that.imgCache[ vStyle.clusterSettings.icon ] === undefined) {
        defs.push(that._createImgLoader(vStyle.clusterSettings.icon));
    }

    if(defClass != null && defClass.icon) {
        defs.push(that._createImgLoader(defClass.icon));
    }

    if(_.isEmpty(that.imgCache)) {
        master.resolve(true);
        return master;
    }

    $.when.apply($, defs).then(function () {
        master.resolve(true);
    });

    for(i in that.imgCache) {
        url = that.project.apiUrlLocation.protocol
            + '//'
            + that.project.apiUrlLocation.hostname
            // Добавилась эта строка
            + (that.project.apiUrlLocation.port ? `:${ that.project.apiUrlLocation.port }` : '')
            + i + '?r=' + Math.floor(Math.random() * (999999)) + 1;

        that.imgCache[ i ].src = url;
    }
    return master;
}

export const omjsModification = () => {
    // @ts-ignore
    omjs['plugins'] = [];
    // Project
    omjs.Project.prototype['getCachedContainers'] = getCachedContainers;
    omjs.Project.prototype['getCachedPubContainers'] = getCachedPubContainers;
    omjs.Project.Layer.prototype['loadObjects'] = loadObjects;
    // View
    omjs.View.prototype['_setMapInteractions'] = function() {
        this.handleMapPointerEvents = this.handleMapPointerEvents.bind(this);
        this.mapEventsOn();
    };

    omjs.View.prototype['setBaseLayer'] = function (layer) {
        this._baseLayer = layer;
        this.getMap().getLayers().setAt(0, layer.olLayer);
    }
    omjs.View.OmsVectorLayer.prototype.setLayerStyle = setLayerStyle;
    omjs.View.VectorLayer.prototype._setup = clusterLayerSetup;
    omjs.View.OmsChartsLayer.prototype['_getChartSize'] = getChartSize;
    omjs.View.OmsChartsLayer.prototype['_getMinMaxValues'] = getMinMaxValues;
    omjs.View.OmsChartsLayer.prototype['_createPieChart'] = createPieChart;
    omjs.View.OmsVectorLayer.prototype[ '_reloadLayerIcons' ] = vectorLayerReloadIcons;
    omjs.View.OmsVectorLayer.prototype[ '_reloadLayerIcons' ] = vectorLayerReloadIcons;
    omjs.View.OmsCategoryLayer.prototype[ '_reloadLayerIcons' ] = categoryLayerReloadIcons;

};
